module.exports = __webpack_public_path__ + "static/img/6.b011abc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/zh/6.png
// module id = oTY2
// module chunks = 0